import React from 'react'
import { useTranslation } from 'react-i18next'
import ResponsiveBreakpointsRolloutBoundary from 'components/ResponsiveBreakpointsRolloutBoundary'
import { RESPONSIVE_BREAKPOINT_PAGES } from 'constants/responsiveBreakpoints'
import { useResponsiveBreakpointsVersion } from 'contexts/ResponsiveBreakpointsContext'
import RecentlyPlayedContentContainer from './RecentlyPlayedContent'

const RecentlyPlayedVersionMarker = () => {
  const version = useResponsiveBreakpointsVersion()

  return (
    <span
      hidden
      data-responsive-breakpoints={version}
      data-responsive-breakpoints-page={
        RESPONSIVE_BREAKPOINT_PAGES.RECENTLY_PLAYED
      } />
  )
}

export const RecentlyPlayedWithRollout = () => {
  const { t } = useTranslation()

  return (
    <ResponsiveBreakpointsRolloutBoundary
      fallback={
        <div className="p-8 text-white" aria-live="polite" role="status">
          {t('general.loading')}
        </div>
      }
      page={RESPONSIVE_BREAKPOINT_PAGES.RECENTLY_PLAYED}>
      <RecentlyPlayedVersionMarker />
      <RecentlyPlayedContentContainer />
    </ResponsiveBreakpointsRolloutBoundary>
  )
}

export default RecentlyPlayedWithRollout
